// Every custom event we capture and the property keys it may carry. An event missing here is
// dropped by the scrub (helpers/posthog/scrub.js) and alarmed to Honeybadger, so adding one is
// a deliberate act. Only key NAMES are ever inspected, never values: keep to ids, enums and
// counts, never free text or names.
export const CUSTOM_EVENTS = {
  mac_moment_notification: ['moment_id', 'moment_count'],
  mac_drawer_opened: []
}
